import type { FC } from "react";
import { Card } from "@/components/flexkit/Card";
import { Text } from "@/components/podkit/typography/Text";
import { CronSelector } from "@/components/flexkit/CronSelector";
import { WorkflowEditCodeContext } from "@/components/automations/AutomationEditCodeContext";
import type { WorkflowEditFormTriggerData } from "@/components/automations/automation-edit-form-data";

type TimeTriggerConfigProps = {
    trigger: WorkflowEditFormTriggerData;
    disabled?: boolean;
    handleConfigChange: (config: WorkflowEditFormTriggerData) => void;
};

export const TimeTriggerConfig: FC<TimeTriggerConfigProps> = ({ trigger, handleConfigChange, disabled = false }) => {
    const cronExpression = trigger.config?.time?.cronExpression || "";

    const handleCronChange = (value: string) => {
        handleConfigChange({
            ...trigger,
            config: {
                ...trigger.config,
                time: {
                    cronExpression: value,
                },
            },
        });
    };

    return (
        <Card variant="bordered" className="flex flex-col gap-4 rounded-lg border-border-base bg-transparent">
            <Text className="text-sm text-content-secondary">
                Schedule your workflow to run automatically at specified times.
            </Text>

            <div className="flex flex-col gap-4">
                <WorkflowEditCodeContext
                    context={trigger.context}
                    disabled={disabled}
                    onChange={(context) => handleConfigChange({ ...trigger, context: context })}
                />

                <div className="flex flex-col gap-2">
                    <Text className="text-base font-medium text-content-primary">Schedule</Text>
                    <CronSelector value={cronExpression} onChange={handleCronChange} showTimezone={true} />
                </div>
            </div>
        </Card>
    );
};
